// extracted by css-extract-rspack-plugin
export default {"mobileTileContainer":"_b2b6d05a"};